import { createBrowserRouter, RouterProvider } from "react-router";

import { ROUTER_ROUTES } from "./router.constant";

const Router = () => {
  return <RouterProvider router={createBrowserRouter(ROUTER_ROUTES)} />;
};

export default Router;
